
function TpaFinRec() {
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>TPA Final Receipt</h5>
                                <br />
                                <div class="live-preview">
                                    <form action="javascript:void(0);">
                                        <div class="row">

                                            <div class="col-md-3">
                                                <div >
                                                    <label for="productname-field" class="form-label">IPD Date</label>
                                                    <input type="date" class="form-control" placeholder="Enter IPD Date" id="firstNameinput" />
                                                       
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div >
                                                    <label for="productname-field" class="form-label">Doctor</label>
                                                    <input type="number" class="form-control" placeholder="Enter Doctor" id="firstNameinput" />
                                                  
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">IPD Number</label>
                                                    <input type="date" class="form-control" placeholder="Enter IPD Number" id="firstNameinput" />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">PRN</label>
                                                    <input type="date" class="form-control" placeholder="Enter PRN" id="firstNameinput" />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">TPA Name</label>
                                                    <input type="text" class="form-control" placeholder="Enter TPA Name" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">File Number</label>
                                                    <input type="text" class="form-control" placeholder="Enter File Number" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Patient</label>
                                                    <input type="text" class="form-control" placeholder="Enter Patient" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Room</label>
                                                    <input type="text" class="form-control" placeholder="Enter Room" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">CCNA Number</label>
                                                    <input type="text" class="form-control" placeholder="Enter CCNA Number" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Card Number</label>
                                                    <input type="text" class="form-control" placeholder="Enter Card Number" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <br /><br />
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">
                                                                        <th scope="col">
                                                                            <div class="form-check">
                                                                                <input class="form-check-input" id="checkAll" type="checkbox" value="option" />
                                                                            </div>
                                                                        </th>
                                                                        <th data-sort="id">S. No.</th>
                                                                        <th data-sort="customer_name">Voucher No</th>
                                                                        <th data-sort="product_name">Date</th>
                                                                        <th data-sort="product_name">Paid</th>
                                                                        <th data-sort="product_name">Receipt AMT</th>
                                                                        <th data-sort="product_name">Refund AMT</th>
                                                                        <th data-sort="product_name">OK</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                                    <tr>
                                                                       
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <div class="noresult">
                                                                <div class="text-center">
                                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                                                                    <h5 class="mt-2">Sorry! No Result Found</h5>
                                                                    <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <br /><br />
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button type="button" class="btn btn-dark">Print Receipt</button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button type="button" class="btn btn-light">Sample Receipt</button>
                                                </div>
                                            </div>

                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TpaFinRec;
